export default "__VITE_ASSET__BT7wb5L___"